import { Pagination, Button, Select, SelectItem } from "@heroui/react";
import { storageKey } from "app/utils/storageKeys";
import { useEffect, useState } from "react";
import { MdArrowBack, MdArrowForward } from "react-icons/md";

const filterLimits = [
  { value: "16", label: "16" },
  { value: "32", label: "32" },
  { value: "44", label: "44" },
];

export type TablePaginationProps = {
  totalPages: number;
  currentPage: number;
  handlePrevious: () => void;
  handleNext: (arg?: number) => void;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
};

export default function TablePagination({
  handleNext,
  handlePrevious,
  totalPages,
  currentPage,
  setLimit,
}: TablePaginationProps): JSX.Element {
  const [limit, setPageLimit] = useState("16");

  useEffect(() => {
    if (window.localStorage) {
      const _limit = localStorage.getItem(storageKey.pageLimit) || "16";
      setPageLimit(_limit);
    }
  }, []);

  return (
    <div className="flex items-center justify-between flex-col md:flex-row w-full gap-4">
      <div className="flex items-center flex-wrap md:flex-nowrap flex-grow gap-4 md:gap-6">
        <Button
          radius="sm"
          variant="bordered"
          className="border font-semibold text-sm"
          startContent={<MdArrowBack className="text-xl" />}
          onPress={handlePrevious}
          isDisabled={currentPage === 1}
        >
          Previous
        </Button>
        <Select
          isDisabled={totalPages <= 1}
          items={filterLimits}
          selectedKeys={[limit]}
          variant="flat"
          size="sm"
          className="w-[80px] h-fit"
          classNames={{
            base: "border bg-white dark:bg-darkest dark:border-dark rounded-lg h-full",
          }}
          onChange={(e) => {
            const value = e.target.value;
            setPageLimit(value);
            setLimit(Number(value));
            localStorage.setItem(storageKey.pageLimit, value);
          }}
          aria-label="filter-table-data"
        >
          {(limit) => <SelectItem key={limit.value}>{limit.label}</SelectItem>}
        </Select>
      </div>
      <Pagination
        initialPage={1}
        page={currentPage}
        total={totalPages}
        onChange={(page) => handleNext(page)}
        className="flex-grow"
      />
      <Button
        radius="sm"
        variant="bordered"
        isDisabled={totalPages === currentPage}
        className="border font-semibold text-sm"
        endContent={<MdArrowForward className="text-xl" />}
        onPress={() => handleNext()}
      >
        Next
      </Button>
    </div>
  );
}
